export const light = {
  name: "light-theme",
  colors: {
    bodyBackground: "var(--grey-50)",
    bodyTextColor: "var(--textColor)",
    btnColor: "var(--white)",
    darkNavLink: "var(--black)",
    sectionHeadingSpan: "var(--primary-700)",
    lightNavLinkAfter: "var(--white)",
    darkNavLinkAfter: "var(--black)",
    aboutSectionBackground: "var(--grey-100)",
    pageHeadingBackground: "var(--primary-100)",
    pageHeadingColor: "var(--primary-700)",
    darkNavLinkActive: "var(--primary-600)",
    lightNavLinkActive: "var(--primary-200)",
    footerBackground: "var(--black)",
    contactLinkColor: "var(--primary-600)",
    projectsButtonColor: "var(--primary-900)",
    projectsButtonBackground: "var(--primary-200)",
    codeLinkColor: "var(--primary-700)",
    codeLinkHover: "var(--primary-100)",
    codeLinkHoverBackground: "var(--primary-900)",
    sidebarTransparent: "rgba(171, 218, 185, 0)",
    sidebarOpaque: "rgba(171, 218, 185, 0.95)",
    docMenuColor: "var(--primary-300)",
    mobileNavToggleColor: "var(--white)",
    mobileNavToggleBackground: "var(--primary-300)",
    sidebarCloseColor: "var(--primary-300)",
    downloadResumeButtonColor: "var(--primary-600)",
    mobileNavToggleHoverBackground: "var(--primary-600)",
    socialIconHoverColor: "var(--primary-400)",
    docNavButtonColor: "var(--primary-100)",
    docNavButtonBackground: "var(--primary-800)",
    sliderSwitchColor: "var(--grey-100)",
    horizontalRuleBorderColor: "var(--grey-900)",
    inlineCodeBackgroundColor: "var(--grey-900)",
    inlineCodeFontColor: "var(--grey-50)",
  },
};

export const dark = {
  name: "dark-theme",
  colors: {
    bodyBackground: "var(--black)",
    bodyTextColor: "var(--grey-50)",
    btnColor: "var(--white)",
    darkNavLink: "var(--white)",
    sectionHeadingSpan: "var(--secondary-500)",
    lightNavLinkAfter: "var(--black)",
    darkNavLinkAfter: "var(--white)",
    aboutSectionBackground: "var(--grey-800)",
    // codeBackgroundColor: "var(--grey-700)",
    pageHeadingBackground: "var(--grey-900)",
    pageHeadingColor: "var(--grey-200)",
    activeNavLink: "var(--primary-200)",
    footerBackground: "var(--grey-900)",
    contactLinkColor: "var(--secondary-300)",
    projectsButtonColor: "var(--secondary-500)",
    projectsButtonBackground: "var(--secondary-1600)",
    codeLinkColor: "var(--secondary-200)",
    codeLinkHover: "var(--secondary-1300)",
    codeLinkHoverBackground: "var(--secondary-200)",
    sidebarTransparent: "rgba(15, 23, 42, 0)",
    sidebarOpaque: "rgba(15, 23, 42, 0.95)",
    docMenuColor: "var(--secondary-600)",
    mobileNavToggleColor: "var(--white)",
    mobileNavToggleBackground: "var(--secondary-600)",
    sidebarCloseColor: "var(--grey-500)",
    lightNavLinkActive: "var(--secondary-600)",
    darkNavLinkActive: "var(--secondary-600)",
    downloadResumeButtonColor: "var(--secondary-1300)",
    mobileNavToggleHoverBackground: "var(--secondary-1300)",
    docMenuHoverColor: "var(--secondary-1300)",
    socialIconHoverColor: "var(--secondary-600)",
    docNavButtonColor: "var(--secondary-300)",
    docNavButtonBackground: "var(--secondary-1300)",
    sliderSwitchColor: "var(--grey-800)",
    horizontalRuleBorderColor: "var(--grey-50)",
    inlineCodeBackgroundColor: "var(--grey-50)",
    inlineCodeFontColor: "var(--grey-900)",
  },
};
